import { Send, MessageCircle, HandHeart, MapPin, Mail, Phone } from "lucide-react";
import { publicFileUrl } from "../lib/plans";

export const ORG_ADDRESS = "Helping Hands Organization, Washington D.C., USA";

export const Cinematic = ({ children, animate }) => {
  const { settings } = useSettings();
  const th = settings?.theme || {};
  if (th.cinematic === false) return <div data-testid="cinematic-off">{children}</div>;
  const o = (th.overlay ?? 82) / 100;
  return (
    <div className="dark cinematic relative isolate text-foreground" data-testid="cinematic-bg">
      <div className="pointer-events-none fixed inset-0 -z-10 overflow-hidden">
        <img src={th.bg_path ? publicFileUrl(th.bg_path) : "/images/cinematic.jpg"} alt="" className={`h-full w-full object-cover ${animate && th.zoom_animation !== false ? "cinematic-reveal" : ""}`} data-testid="cinematic-image" />
        <div className="absolute inset-0" style={{ background: `linear-gradient(to bottom, rgba(5,7,12,${o}), rgba(7,10,18,${Math.max(0, o - 0.05)}), rgba(5,7,12,${Math.min(1, o + 0.12)}))` }} />
        <div className="absolute inset-0" style={{ background: "radial-gradient(ellipse at 70% 0%, var(--gold-soft), transparent 55%)" }} />
      </div>
      {children}
    </div>
  );
};
import { useI18n } from "../i18n";
import { useSettings } from "../lib/providers";

export const ContactSection = () => {
  const { t } = useI18n();
  const { settings } = useSettings();
  const c = settings?.contact || {};
  const wa = `https://wa.me/${(c.whatsapp || "").replace(/\D/g, "")}`;
  return (
    <section id="contact" className="mx-auto max-w-7xl px-5 py-24 lg:px-8">
      <div className="lux-card grain relative grid gap-10 overflow-hidden p-10 md:grid-cols-[1.2fr_1fr] md:p-14">
        <div>
          <p className="eyebrow">{t("contact_eyebrow")}</p>
          <h2 className="mt-3 font-serif text-4xl font-semibold sm:text-5xl">{t("contact_title")}</h2>
          <p className="mt-4 max-w-md text-muted-foreground">{t("contact_sub")}</p>
          <div className="mt-8 flex items-start gap-3" data-testid="contact-address">
            <MapPin className="mt-0.5 h-5 w-5 shrink-0" style={{ color: "var(--gold)" }} />
            <div><p className="text-xs uppercase tracking-widest text-muted-foreground">{t("address_label")}</p><p className="mt-1 font-medium">{c.address || ORG_ADDRESS}</p></div>
          </div>
          {c.email && <a href={`mailto:${c.email}`} className="mt-4 flex items-center gap-3 text-sm" data-testid="contact-email"><Mail className="h-5 w-5" style={{ color: "var(--gold)" }} />{c.email}</a>}
          {c.phone && <a href={`tel:${c.phone}`} className="mt-3 flex items-center gap-3 text-sm" data-testid="contact-phone"><Phone className="h-5 w-5" style={{ color: "var(--gold)" }} />{c.phone}</a>}
        </div>
        <div className="flex flex-col justify-center gap-4">
          <a href={c.telegram} target="_blank" rel="noreferrer" className="group flex items-center gap-4 rounded-2xl border p-5 transition-colors hover:bg-[#229ED9]/10" data-testid="contact-telegram-btn">
            <span className="flex h-12 w-12 items-center justify-center rounded-full bg-[#229ED9] text-white transition-transform group-hover:scale-110"><Send className="h-5 w-5" /></span>
            <span className="font-semibold">{t("contact_telegram")}</span>
          </a>
          <a href={wa} target="_blank" rel="noreferrer" className="group flex items-center gap-4 rounded-2xl border p-5 transition-colors hover:bg-[#25D366]/10" data-testid="contact-whatsapp-btn">
            <span className="flex h-12 w-12 items-center justify-center rounded-full bg-[#25D366] text-white transition-transform group-hover:scale-110"><MessageCircle className="h-5 w-5" /></span>
            <span className="font-semibold">{t("contact_whatsapp")}</span>
          </a>
        </div>
      </div>
    </section>
  );
};

export const Footer = () => {
  const { t } = useI18n();
  const { settings } = useSettings();
  const name = settings?.branding?.site_name || "Helping Hands";
  return (
    <footer className="border-t">
      <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-3 px-5 py-8 text-sm text-muted-foreground sm:flex-row lg:px-8">
        <span className="flex items-center gap-2"><HandHeart className="h-4 w-4" style={{ color: "var(--gold)" }} /> {name}</span>
        <span className="flex items-center gap-2" data-testid="footer-address"><MapPin className="h-4 w-4" style={{ color: "var(--gold)" }} /> {settings?.contact?.address || ORG_ADDRESS}</span>
        <span>© {new Date().getFullYear()} {name}. {t("footer_rights")}</span>
      </div>
    </footer>
  );
};
